import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOne = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M9.37415 16.8V15.4464H11.4189V9.4272H9.73415V8.3904C10.1853 8.304 10.5789 8.2032 10.9149 8.088C11.2509 7.9632 11.5629 7.8144 11.8509 7.6416H13.0893V15.4464H14.8893V16.8H9.37415Z",
		fill: "currentcolor"
	})]
});
export default SvgOne;
